import styles from './ErrorPage.module.scss'
import { IClass } from '@/interfaces/general'
import Button from '@/components/Primitive/Buttons/Button/Button'
import { useState } from 'react'
import classNames from 'classnames'
import Logo from '@/components/Logo/Logo'
import CirclePreloader from '@/components/Primitive/CirclePreloader/CirclePreloader'
import { FormattedMessage } from 'react-intl'
import { isIOSApp, reloadPageOnIOS } from '@/utils/app'

type ErrorPageProps = IClass

const ErrorPage = ({ className }: ErrorPageProps) => {
  const [loading, setLoading] = useState(false)
  const [loadingError, setLoadingError] = useState<string | null>(null)

  const reloadApp = async() => {
    setLoading(true)
    setLoadingError(null)
    try {
      const response = await fetch('/', {
        cache: 'reload'
      })
      if (!response.ok) {
        throw new Error('Could not reload the page')
      }
      if (isIOSApp()) {
        if (!reloadPageOnIOS()) {
          setLoadingError('you_use_old_version')
        }
      } else {
        window.location.reload()
      }
    } catch (e) {
      setLoading(false)
      setLoadingError('check_network_module_error')
    }
  }
  return <div className={classNames(styles.box, className)}>
    <div className={styles.context}>
      <Logo full className={styles.logo}/>
      <FormattedMessage id="module_loaded_error">
        {txt => <p className={styles.text}>{txt}</p>}
      </FormattedMessage>
      <FormattedMessage id="reload">
        {txt => <Button
          className={styles.btn}
          disabled={loading}
          onClick={reloadApp}
        >
          {txt}
        </Button>}
      </FormattedMessage>
      {loading && <CirclePreloader className={styles.spinner} withoutProgress color={'var(--main-color)'}/>}
      {!!loadingError && <FormattedMessage id={loadingError}>
        {txt => <span className={classNames(styles.text, styles.error)}>{txt}</span>}
      </FormattedMessage>
      }
    </div>
  </div>
}

export default ErrorPage
